import { singletonFactory } from '@warehouse/shared/util';
import { HostBridgeFactory } from './quickbase-host-bridge';
import { createQuickbaseHostBridge } from './quickbase-host-bridge.impl';

export const hostBridgeFactorySingleton = singletonFactory<HostBridgeFactory>({
	factory: () => createQuickbaseHostBridge,
});
